import { api } from '../../api'
import getPersonalResult from '../school/getPersonalResult'
import getAllCenters from './getAllCenters'
import getAllCentersTse from './getAllCentersTse'
import getCenterwiseMeritListShatabdi from './getCenterwiseMeritListShatabdi'
import getCenterwiseMeritListTse from './getCenterwiseMeritListTse'
import getResult from './getResult'
import getTseResult from './getTseResult'


export const resultsApi = api.injectEndpoints({
    endpoints: build => ({
        GetAllCenters: getAllCenters(build),         
        GetResult:getResult(build),  
        GetResultTse:getTseResult(build),   
        GetCenterMeritListShatabdi:getCenterwiseMeritListShatabdi(build),
        GetCenterMeritListTse:getCenterwiseMeritListTse(build),

        GetAllCentersTse:getAllCentersTse(build)

    }),
    overrideExisting: true,   
})
export const {
    useGetAllCentersQuery,
    useGetAllCentersTseQuery,
    useGetResultMutation,
    useGetCenterMeritListShatabdiMutation,
    useGetCenterMeritListTseMutation,
    useGetResultTseMutation
} = resultsApi
